import './button.scss'

import { FC } from 'react'
import { Image } from 'react-bootstrap'
import { button_t } from 'src/types'
import { join_str } from 'src/utils'

import { flavors } from './button.flavors'

export const Button: FC<button_t> = ({
  text,
  flavor,
  type = 'button',
  disabled,
  iconl,
  iconr,
  icon_size = 16,
  form_id,
  classes,
  classes_text = 'font-14-semibold text-uppercase',
  classes_iconl = 'mr-3',
  classes_iconr = 'ml-3',
  on_press,
}: button_t) => {
  const fl = flavors[flavor || '']
  const iconl_ = iconl || fl?.iconl
  const iconr_ = iconr || fl?.iconr
  const isize_ = {
    height: icon_size,
    width: icon_size,
  }

  return (
    <button
      type={type}
      className={join_str(classes, fl?.classes)}
      disabled={disabled}
      onClick={on_press}
      form={form_id}
    >
      {/* ICON LEFT */}
      {iconl_ && (
        <Image {...isize_} src={iconl_} className={join_str(classes_iconl, fl?.classes_iconl)} />
      )}

      {/* TEXT */}
      <span className={join_str(classes_text, fl?.classes_text)}>{text}</span>

      {/* ICON RIGHT */}
      {iconr_ && (
        <Image {...isize_} src={iconr_} className={join_str(classes_iconr, fl?.classes_iconr)} />
      )}
    </button>
  )
}
